/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Feedback_Question_TitleInputs */

const en_ai_feedback_question_title = /** @type {(inputs: Ai_Feedback_Question_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question: AI feedback on your resume`)
};

const de_ai_feedback_question_title = /** @type {(inputs: Ai_Feedback_Question_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abfrage: KI-Feedback zu deinem Lebenslauf`)
};

/**
* | output |
* | --- |
* | "Question: AI feedback on your resume" |
*
* @param {Ai_Feedback_Question_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_feedback_question_title = /** @type {((inputs?: Ai_Feedback_Question_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Feedback_Question_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_feedback_question_title(inputs)
	return en_ai_feedback_question_title(inputs)
});